import { Gender, Profile } from '@/pages/Profile/Profile.types';
import { zeblineAnalytics } from '@/services/analytics';

export const trackZeblineEvents = zeblineAnalytics.send.bind(zeblineAnalytics);
export const zeblineSetUserAttribute = zeblineAnalytics.setAttribute.bind(zeblineAnalytics);
export const zeblineSetUserAttributes = zeblineAnalytics.setAttributes.bind(zeblineAnalytics);
export const zeblineLoginUser = zeblineAnalytics.login.bind(zeblineAnalytics);
export const zeblineLogoutUser = zeblineAnalytics.logout.bind(zeblineAnalytics);

export const zeblineUpdateUserProfile = (user: Partial<Profile>) => {
  if (user.email) {
    zeblineSetUserAttribute<'email'>('email', user.email);
  }

  if (user.mobileNumber) {
    zeblineSetUserAttribute<'mobile'>('mobile', user.mobileNumber.toString());
  }

  if (user.gender !== undefined && user.gender !== null) {
    let gender = '';

    switch (user.gender) {
      case Gender.Male:
        gender = 'male';
        break;

      case Gender.Female:
        gender = 'female';
        break;

      default:
        gender = 'prefer_not_to_say';
        break;
    }

    zeblineSetUserAttribute<'gender'>('gender', gender);
  }

  if (user.occupation) {
    zeblineSetUserAttribute<'job_title'>('job_title', user.occupation);
  }

  if (user.birthDate) {
    zeblineSetUserAttribute<'birth_date'>('birth_date', new Date(user.birthDate));
  }
};
